import { create } from "zustand";
import { persist } from "zustand/middleware";

interface LawTermToggleStore {
  toggleLawTermShow: boolean;
  setToggleLawTermShow: (toggleLawTermShow: boolean) => void;
}

const useLawTermToggleStore = create<LawTermToggleStore>()(
  persist(
    (set) => ({
      toggleLawTermShow: true,
      setToggleLawTermShow: (toggleLawTermShow) => set({ toggleLawTermShow }),
    }),
    {
      name: "law-term-toggle-storage", // unique name for localStorage key
    }
  )
);

export default useLawTermToggleStore;
